import axios from "../utils/axios";

// Get all payments with pagination
export const getAdminPaymentsApi = (params = {}) => {
  return axios.get("/api/restaurant/payment/admin/payments", {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      status: params.status || undefined,
      restaurantId: params.restaurantId || undefined,
      invoiceId: params.invoiceId || undefined,
      paymentMethod: params.paymentMethod || undefined,
      startDate: params.startDate || undefined,
      endDate: params.endDate || undefined,
      search: params.search || undefined,
    },
    withCredentials: true,
  });
};

// Get pending payments
export const getPendingPaymentsApi = () => {
  return axios.get("/api/restaurant/payment/admin/pending-payments", {
    withCredentials: true,
  });
};

// Approve payment
export const approvePaymentApi = (id) => {
  return axios.put(
    `/api/restaurant/payment/admin/approve-payment/${id}`,
    {},
    {
      withCredentials: true,
    }
  );
};

// Reject payment
export const rejectPaymentApi = (id) => {
  return axios.put(
    `/api/restaurant/payment/admin/reject-payment/${id}`,
    {},
    {
      withCredentials: true,
    }
  );
};